import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whatsapp-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 122.8c35.2 0 68.2 13.7 93.2 38.7 24.9 24.9 40.1 58 40.1 93.2 0 72.7-60.7 131.8-133.3 131.8h-0.1c-23.7 0-46.9-6.4-67.1-18.4l-4.8-2.9-49.9 13.1 13.3-48.6-3.1-5c-13.2-20.9-20.2-45.2-20.2-70.1 0.1-72.7 59.2-131.8 131.9-131.8zM301.5 311.2c3.3-9.2 3.3-17.2 2.4-19.1-1-1.6-3.6-2.6-7.6-4.6s-23.5-11.6-27.1-12.9c-3.6-1.3-6.3-2-8.9 2-2.6 3.9-10.2 12.9-12.5 15.5-2.3 2.7-4.6 3-8.6 1-23.3-11.7-38.6-20.8-53.9-47.1-4.1-7 4-6.4 11.6-21.6 1.4-2.6 0.7-4.9-0.3-6.9s-8.9-21.5-12.2-29.4c-3.2-7.7-6.5-6.7-8.9-6.8-2.3-0.1-5-0.1-7.6-0.1-2.7 0-7 1-10.6 5-3.7 4-13.9 13.6-13.9 33.1s14.2 38.4 16.2 41c2 2.6 28 42.6 67.7 59.8 25.1 10.8 34.9 11.8 47.5 9.9 7.6-1.1 23.4-9.5 26.7-18.8zM400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM223.9 413.2c87.4 0 160.1-71.1 160.1-158.5 0-42.4-18-82.2-47.9-112.2-30-30-69.8-46.5-112.2-46.5-87.4 0-158.5 71.1-158.6 158.5 0 28 7.3 55.3 21.2 79.3l-22.5 82.2 84.1-22.1c23.1 12.6 49.2 19.3 75.8 19.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whatsapp-square.js
// module id = 1091
// module chunks = 0